/* eslint-disable no-tabs */
import React, { useEffect, useRef } from 'react';
import {
  Form, Row, Col,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { generateFlightSearchInputs } from '../../helper';
import translations from '../../../../screens/Search/translations';
import { useI18nContext } from '../../../../utils/I18n';
import { FlightSearchForm } from './MultiDestinationsFlightSearchForm';
import {AddItem, MultiCityFormWrapper} from "../styles";
import { getMultiDestinationRange } from '../../../../utils/helpers';

type MulticityFlightSearchFormProps = {
    airportOptions: SelectOption[];
    MultiCityMaxRoute: number;
    form: any;
  limitSuggestionHeight?: boolean;
  title?: string;
  className?: string;
  onClose: () => void;
  DestinationLocationCode?: string;
  OriginLocationCode?: string;
  DepartureDate?: any;
    visible: boolean;
  setVisible: (value: boolean) => void;
}
export function MultiDestinationsFlightSearchForm(props: MulticityFlightSearchFormProps) {
  const {
    MultiCityMaxRoute,
    form,
    airportOptions,
    visible,
    setVisible,
    DestinationLocationCode,
    OriginLocationCode,
    DepartureDate
  } = props;

  const {
    state: { t },
  } = useI18nContext();
  const modalContainerRef = useRef(null);

  const multiCities = form.getFieldValue('multiCity');

  const origin = form.getFieldValue("OriginLocationCode");
  const destination = form.getFieldValue("DestinationLocationCode");
  const departureDate = DepartureDate ?? form.getFieldValue("DepartureDate");
  
  const firstDepartureDate = getMultiDestinationRange(departureDate);
  // const initialValue = multiCities?.length > 0
  //   ? multiCities.map((item) => ({ ...item, DepartureDate: moment(item.DepartureDate) })) : generateFlightSearchInputs(2);

  const initialValue =
    multiCities?.length > 0
      ? multiCities.map((item) => ({
          ...item,
          DepartureDate: getMultiDestinationRange(item.DepartureDate),
        }))
      : [
          {
            OriginLocationCode: origin,
            DestinationLocationCode: destination,
            DepartureDate: firstDepartureDate,
          },
          ...generateFlightSearchInputs(1),
      ];
  
  useEffect(() => {
      form.setFieldsValue({
        trips: initialValue,
      });
  }, []);

  return (
    <Col span={24}>
        <Row gutter={8}>
          <Form.List name="trips" initialValue={initialValue}>
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <Col xs={24} lg={24} key={`itemWrapper${field.key}`}>
                    <Row>
                      {field.name > 1 && (
                        <Col>
                          {' '}
                          <CloseOutlined onClick={() => remove(field.name)} key={`outline${field.key}`} />
                        </Col>
                      ) }

                    </Row>
                    <MultiCityFormWrapper>
                      <FlightSearchForm
                          field={field}
                          key={field.key}
                          form={form}
                      />
                    </MultiCityFormWrapper>
                  </Col>
                ))}

                <Col xs={24} lg={24}>
                  <Form.Item>
                    <AddItem
                        onClick={fields?.length === 5 ? null : add}
                        disabled={fields.length >= MultiCityMaxRoute}
                    >
                      +
                      {' '}
                      {t(translations).addNewButton}
                    </AddItem>
                  </Form.Item>
                </Col>
              </>
            )}
          </Form.List>
        </Row>
      </Col>
  );
}
